/**
 * Vite 환경 변수 접근을 한 곳에 모은다.
 * `import.meta.env` 는 Vite 전용 문법이라 jest(ts-jest, CJS)에서 컴파일되지 않는다 —
 * 컴포넌트가 직접 참조하면 그 컴포넌트를 단위 테스트할 수 없으므로 이 모듈을 거쳐 읽고, 테스트에서는 이 모듈을 목 처리한다.
 */
export const getViteMode = (): string => import.meta.env.VITE_MODE as string
